/**
 * 视频草稿标题(1005 生产实测)。
 *
 * 病:用户在「任务名」里填了「b验收-硬广分镜-钻戒15s」,智能编排成功后草稿列表里的标题却是 AI 主题句
 *   ——草稿命名此前只看 theme / userInput / briefPurpose,任务名(`form.name`)根本没进判据,
 *   编排写回 theme 后 2.5s 自动保存就把标题换成了主题句。
 * 规则:用户填了任务名就用任务名;没填才按 主题 → 原话 → 目的 兜底。
 */
export interface VideoDraftNameInput {
  name?: string | null;
  theme?: string | null;
  userInput?: string | null;
  briefPurpose?: string | null;
}

export function videoDraftName(s: VideoDraftNameInput): string {
  const userNamed = (s.name ?? "").trim();
  if (userNamed) return userNamed.slice(0, 40);
  return (s.theme || s.userInput || s.briefPurpose || "").trim().slice(0, 40) || "未命名视频草稿";
}
